/* KISHI KAISEI — compléments front (chargé sur toutes les pages). */
(function(){
  'use strict';
  var settings = window.themeSettings || {};
  var routes = window.routes || {};

  /* ---------- Collection : bouton « Supprimer les filtres » ---------- */
  function initClearFilters(){
    var form = document.querySelector('[data-filter-form]');
    if(!form) return;
    if(form.querySelector('.kk-clear-filters')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'chip chip--clear kk-clear-filters';
    btn.textContent = 'Supprimer les filtres';
    var count = form.querySelector('[data-kk-count]');
    if(count){ form.insertBefore(btn, count); } else { form.appendChild(btn); }
    function anyActive(){
      if(window.location.search.indexOf('filter.') > -1) return true;
      return !!form.querySelector('input[data-kk-filter]:checked');
    }
    function updateVisibility(){ btn.style.display = anyActive() ? '' : 'none'; }
    updateVisibility();
    form.addEventListener('change', function(e){ if(e.target && e.target.matches('input[data-kk-filter]')) updateVisibility(); });
    btn.addEventListener('click', function(){
      var kkBoxes = form.querySelectorAll('input[data-kk-filter]');
      var hadKk = false;
      for(var i=0;i<kkBoxes.length;i++){ if(kkBoxes[i].checked){ kkBoxes[i].checked = false; hadKk = true; } }
      if(hadKk && kkBoxes.length){ kkBoxes[0].dispatchEvent(new Event('change', { bubbles:true })); }
      updateVisibility();
      if(window.location.search){ window.location.href = window.location.pathname; }
    });
  }

  /* ---------- Fiche produit : galerie (flèches + slide + zoom baladeur) ---------- */
  function initGallery(){
    var main = document.querySelector('[data-gallery-main]');
    if(!main) return;
    var mainImg = main.querySelector('img');
    if(!mainImg) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
    var srcs = [];
    for(var i=0;i<thumbs.length;i++){ if(thumbs[i].dataset.full){ srcs.push(thumbs[i].dataset.full); } }
    if(!srcs.length){ srcs = [mainImg.currentSrc || mainImg.src]; }
    for(var pi=0; pi<srcs.length; pi++){ var im = new Image(); im.src = srcs[pi]; }

    function curIndex(){ for(var t=0;t<thumbs.length;t++){ if(thumbs[t].classList.contains('is-active')){ return t; } } return 0; }
    function showMain(i){ i=(i+srcs.length)%srcs.length; mainImg.src=srcs[i]; mainImg.removeAttribute('srcset'); for(var t=0;t<thumbs.length;t++){ thumbs[t].classList.toggle('is-active', t===i); } }

    main.classList.add('kk-zoomable');

    if(srcs.length > 1){
      var prev = document.createElement('button');
      prev.type='button'; prev.className='kk-gal-nav kk-gal-prev'; prev.setAttribute('aria-label','Photo précédente'); prev.innerHTML='‹';
      var next = document.createElement('button');
      next.type='button'; next.className='kk-gal-nav kk-gal-next'; next.setAttribute('aria-label','Photo suivante'); next.innerHTML='›';
      prev.addEventListener('click', function(e){ e.stopPropagation(); showMain(curIndex()-1); });
      next.addEventListener('click', function(e){ e.stopPropagation(); showMain(curIndex()+1); });
      main.appendChild(prev); main.appendChild(next);
    }

    var suppressClick = false;
    if(srcs.length > 1){
      var sx=0, sy=0, tracking=false;
      main.addEventListener('touchstart', function(e){ var t=e.touches[0]; sx=t.clientX; sy=t.clientY; tracking=true; }, {passive:true});
      main.addEventListener('touchend', function(e){
        if(!tracking) return; tracking=false;
        var t=e.changedTouches[0]; var dx=t.clientX-sx, dy=t.clientY-sy;
        if(Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)){ showMain(curIndex() + (dx<0?1:-1)); suppressClick=true; setTimeout(function(){ suppressClick=false; }, 400); }
      }, {passive:true});
    }

    main.addEventListener('click', function(e){
      if(suppressClick){ suppressClick=false; return; }
      if(e.target && e.target.closest && e.target.closest('.kk-gal-nav')) return;
      openLightbox(curIndex());
    });

    function openLightbox(start){
      var lb = document.createElement('div');
      lb.className = 'kk-lb';
      var nav = srcs.length>1 ? '<button type="button" class="kk-lb-nav kk-lb-prev" aria-label="Précédent">‹</button><button type="button" class="kk-lb-nav kk-lb-next" aria-label="Suivant">›</button>' : '';
      lb.innerHTML = '<button type="button" class="kk-lb-close" aria-label="Fermer">×</button><img class="kk-lb-img" src="'+srcs[start]+'" alt="" draggable="false">'+nav;
      document.body.appendChild(lb);
      document.body.style.overflow = 'hidden';
      var img = lb.querySelector('.kk-lb-img');
      img.draggable = false;
      img.addEventListener('dragstart', function(e){ e.preventDefault(); });
      var idx = start, scale=1, panX=0, panY=0, dragging=false, gsx=0, gsy=0, moved=false, downX=0, downY=0;
      function apply(){ img.style.transform = 'translate('+panX+'px,'+panY+'px) scale('+scale+')'; }
      function resetZoom(){ scale=1; panX=0; panY=0; img.classList.remove('is-zoom'); img.style.transition='transform .2s ease'; img.style.cursor='zoom-in'; apply(); }
      function setImg(i){ idx=(i+srcs.length)%srcs.length; img.src=srcs[idx]; resetZoom(); }
      function close(){ if(lb.parentNode){ lb.parentNode.removeChild(lb); } document.body.style.overflow=''; document.removeEventListener('keydown', onKey); }
      function onKey(e){ if(e.key==='Escape'){ close(); } else if(e.key==='ArrowLeft'){ setImg(idx-1); } else if(e.key==='ArrowRight'){ setImg(idx+1); } }
      lb.querySelector('.kk-lb-close').addEventListener('click', close);
      lb.addEventListener('click', function(e){ if(e.target===lb){ close(); } });
      var p=lb.querySelector('.kk-lb-prev'), n=lb.querySelector('.kk-lb-next');
      if(p){ p.addEventListener('click', function(e){ e.stopPropagation(); setImg(idx-1); }); }
      if(n){ n.addEventListener('click', function(e){ e.stopPropagation(); setImg(idx+1); }); }
      img.addEventListener('pointerdown', function(e){
        e.preventDefault(); e.stopPropagation(); downX=e.clientX; downY=e.clientY; moved=false;
        if(scale>1){ dragging=true; gsx=e.clientX-panX; gsy=e.clientY-panY; img.style.transition='none'; img.style.cursor='grabbing'; try{ img.setPointerCapture(e.pointerId); }catch(_){} }
      });
      img.addEventListener('pointermove', function(e){
        if(Math.abs(e.clientX-downX)>8 || Math.abs(e.clientY-downY)>8){ moved=true; }
        if(!dragging) return;
        panX = e.clientX - gsx; panY = e.clientY - gsy; apply();
      });
      img.addEventListener('pointerup', function(e){
        e.stopPropagation();
        if(dragging){ dragging=false; img.style.transition='transform .2s ease'; img.style.cursor='grab'; }
        if(moved){ return; }
        if(scale===1){ scale=2.4; img.classList.add('is-zoom'); img.style.cursor='grab'; apply(); } else { resetZoom(); }
      });
      var tsx=0, tsy=0, tr=false;
      lb.addEventListener('touchstart', function(e){ if(scale>1) return; var t=e.touches[0]; tsx=t.clientX; tsy=t.clientY; tr=true; }, {passive:true});
      lb.addEventListener('touchend', function(e){ if(!tr||scale>1) return; tr=false; var t=e.changedTouches[0]; var dx=t.clientX-tsx, dy=t.clientY-tsy; if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)){ setImg(idx + (dx<0?1:-1)); } }, {passive:true});
      document.addEventListener('keydown', onKey);
    }
  }

  /* ---------- Fiche produit : ETA sur 2 lignes ---------- */
  function formatEta(){
    var eta = document.querySelector('.pdp-eta span');
    if(!eta) return;
    if(eta.getAttribute('data-kk-eta') === '1') return;
    if(/Commandez-le maintenant et recevez-le/i.test(eta.innerHTML)){
      eta.innerHTML = eta.innerHTML.replace(/Commandez-le maintenant et recevez-le/i, 'Commandez-le maintenant :<br>Recevez-le');
      eta.setAttribute('data-kk-eta', '1');
    }
  }
  function watchEta(){
    var box = document.querySelector('[data-pdp-eta]');
    formatEta();
    if(box && window.MutationObserver){ new MutationObserver(function(){ formatEta(); }).observe(box, { childList:true, subtree:true }); }
  }

  /* ---------- Newsletter : « Désinscription en un clic » à la ligne ---------- */
  function formatNewsletterFine(){
    var fine = document.querySelector('.news .fine');
    if(!fine || fine.getAttribute('data-kk')==='1') return;
    if(fine.innerHTML.indexOf('Désinscription') > -1){
      fine.innerHTML = fine.innerHTML.replace(/\s*Désinscription/, '<br>Désinscription');
      fine.setAttribute('data-kk','1');
    }
  }

  /* ---------- Menu mobile : sous-catégories en accordéon ---------- */
  function initMobileSubmenus(){
    var nav = document.querySelector('.mobile-menu nav');
    if(!nav) return;
    var subs = nav.querySelectorAll('.mobile-sub');
    for(var i=0;i<subs.length;i++){
      var sub = subs[i];
      var link = sub.previousElementSibling;
      if(!link || link.tagName !== 'A' || link.querySelector('.kk-sub-toggle')) continue;
      sub.classList.add('kk-sub-collapsed');
      var tog = document.createElement('button');
      tog.type='button'; tog.className='kk-sub-toggle'; tog.setAttribute('aria-label','Afficher le sous-menu'); tog.innerHTML='+';
      (function(sub, tog){
        tog.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var open = sub.classList.toggle('kk-sub-open');
          sub.classList.toggle('kk-sub-collapsed', !open);
          tog.innerHTML = open ? '−' : '+';
        });
      })(sub, tog);
      link.appendChild(tog);
    }
  }

  /* ---------- Quiz : retirer la porte email (reco affichée directement) ---------- */
  function disableQuizEmailGate(){
    if(document.querySelector('[data-kkq2]')){
      window.kkEmailGate = function(onOk){ if(typeof onOk === 'function'){ onOk(); } };
    }
  }

  /* ---------- Ajout au panier : l'image vole vers le panier, SANS ouvrir le tiroir ---------- */
  function flyToCart(){
    var srcImg = document.querySelector('[data-gallery-main] img');
    var cart = document.querySelector('[data-cart-toggle]');
    if(!srcImg || !cart) return;
    var s = srcImg.getBoundingClientRect();
    var c = cart.getBoundingClientRect();
    if(!s.width || !c.width) return;
    var size = Math.min(s.width, 110);
    var fly = document.createElement('img');
    fly.src = srcImg.currentSrc || srcImg.src;
    fly.className = 'kk-fly';
    fly.style.left = s.left + 'px'; fly.style.top = s.top + 'px'; fly.style.width = size + 'px';
    document.body.appendChild(fly);
    fly.getBoundingClientRect();
    var tx = (c.left + c.width/2) - (s.left + size/2);
    var ty = (c.top + c.height/2) - (s.top + size/2);
    fly.style.transform = 'translate('+tx+'px,'+ty+'px) scale(0.12)';
    fly.style.opacity = '0.25';
    setTimeout(function(){ if(fly.parentNode){ fly.parentNode.removeChild(fly); } cart.classList.add('kk-cart-bump'); setTimeout(function(){ cart.classList.remove('kk-cart-bump'); }, 400); }, 720);
  }
  function silentRefreshDrawer(){
    var d = document.querySelector('[data-cart-drawer]');
    if(!d) return;
    fetch('/?sections=cart-drawer').then(function(r){ return r.json(); }).then(function(data){
      var html = data && data['cart-drawer']; if(!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.querySelector('[data-cart-drawer]');
      if(fresh){ var open = d.classList.contains('is-open'); d.innerHTML = fresh.innerHTML; if(open){ d.classList.add('is-open'); } }
    }).catch(function(){});
  }
  function initAddToCart(){
    document.addEventListener('submit', function(e){
      var form = e.target;
      if(!form || !form.matches || !form.matches('.product-form')) return;
      if(settings.cartType === 'none') return;
      e.preventDefault(); e.stopPropagation();
      var btn = form.querySelector('[data-add-to-cart]');
      var label = btn ? btn.querySelector('[data-add-label]') : null;
      var original = label ? label.textContent : '';
      var errorBox = document.querySelector('[data-form-error]');
      if(btn){ btn.disabled = true; }
      if(label){ label.textContent = 'Ajout…'; }
      if(errorBox){ errorBox.hidden = true; errorBox.textContent = ''; }
      flyToCart();
      fetch(routes.cart_add_url || '/cart/add.js', { method:'POST', headers:{ Accept:'application/javascript' }, body: new FormData(form) })
        .then(function(r){ return r.json().then(function(b){ if(!r.ok){ throw b; } return b; }); })
        .then(function(){
          return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
            var counts = document.querySelectorAll('[data-cart-count]');
            for(var i=0;i<counts.length;i++){ counts[i].textContent = cart.item_count; }
            if(label){ label.textContent = 'Ajouté ✓'; }
            silentRefreshDrawer();
          });
        })
        .catch(function(err){
          var message = (err && (err.description || err.message)) || "Impossible d'ajouter au panier.";
          if(errorBox){ errorBox.textContent = message; errorBox.hidden = false; } else { window.alert(message); }
          if(label){ label.textContent = original; }
        })
        .then(function(){ if(btn){ btn.disabled = false; } setTimeout(function(){ if(label && label.textContent === 'Ajouté ✓'){ label.textContent = original; } }, 1800); });
    }, true);
  }

  function init(){ initClearFilters(); initGallery(); watchEta(); formatNewsletterFine(); initMobileSubmenus(); disableQuizEmailGate(); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
  initAddToCart();
})();
